module.exports = __webpack_public_path__ + "img/dropbox.a4c8edcd.png";